
export const translitMap = {
    А: "A",
    Б: "B",
    В: "V",
    Г: "G",
    Д: "D",
    Е: "E",
    Ё: "Yo",
    Ж: "Zh",
    З: "Z",
    И: "I",
    Й: "J",
    К: "K",
    Л: "L",
    М: "M",
    Н: "N",
    О: "O",
    П: "P",
    Р: "R",
    С: "S",
    Т: "T",
    У: "U",
    Ф: "F",
    Х: "X",
    Ц: "C",
    Ч: "Ch",
    Ш: "Sh",
    Щ: "Shh",
    ъ: "``",
    Ы: "Y`",
    ь: "`",
    Э: "E`",
    Ю: "Yu",
    Я: "Ya",
    а: "a",
    б: "b",
    в: "v",
    г: "g",
    д: "d",
    е: "e",
    ё: "yo",
    ж: "zh",
    з: "z",
    и: "i",
    й: "j",
    к: "k",
    л: "l",
    м: "m",
    н: "n",
    о: "o",
    п: "p",
    р: "r",
    с: "s",
    т: "t",
    у: "u",
    ф: "f",
    х: "x",
    ц: "c",
    ч: "ch",
    ш: "sh",
    щ: "shh",
    ы: "y`",
    э: "e`",
    ю: "yu",
    я: "ya",
    "№": "#",
  };


export function transliterate(text) {
    return text.split('').map(char => translitMap[char] || char).join('');
}



export function splitFullName(fullName) {
  const parts = fullName.trim().split(/\s+/);
  if (parts.length < 2) {
      return { lastName: fullName, firstMiddleName: '' };
  }
  const lastName = parts.shift();
  const firstMiddleName = parts.join(' ');
  return { lastName, firstMiddleName };
}